import { isStandOccupiedToday } from './clubStandList';

export const CLUB_WAYPOINT_DELETE =
  'Delete this waypoint? Hunt logs stay. The pin and its feed log leave the club map. This cannot be undone.';

export const CLUB_WAYPOINT_DELETE_OCCUPIED =
  'Someone is tagged out here today.';

export function clubWaypointNumericId(location) {
  if (location == null) return null;
  const loc = location.location && location.location.id != null
    ? location.location
    : location;
  if (loc?.id == null) return null;
  const raw = String(loc.id).replace(/^location-/, '');
  const n = parseInt(raw, 10);
  return Number.isFinite(n) ? n : null;
}

export function clubWaypointOccupiedToday(location, { stands = [], locations = [] } = {}) {
  if (!location) return false;
  if (location.isOccupied) return true;
  const nested = location.location && location.location.id != null
    ? location.location
    : location;
  if (isStandOccupiedToday(nested)) return true;
  const id = clubWaypointNumericId(location);
  if (id == null) return false;
  const stand = stands.find((row) => Number(row.id) === id);
  if (stand?.isOccupied) return true;
  const full = locations.find((row) => Number(row.id) === id);
  return isStandOccupiedToday(full);
}

export function clubWaypointDeletePlan(location, lookup = {}) {
  const id = clubWaypointNumericId(location);
  if (id == null) return null;
  const occupied = clubWaypointOccupiedToday(location, lookup);
  return {
    title: 'Delete waypoint',
    body: occupied
      ? `${CLUB_WAYPOINT_DELETE} ${CLUB_WAYPOINT_DELETE_OCCUPIED}`
      : CLUB_WAYPOINT_DELETE,
    occupied,
    id,
  };
}
